import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stktu { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @MaxLength(1,{message: '流程碼 (KEY0) 資料太長'})
    KEY0: string = '1';            // 流程碼 1 [DEF:"1"]

    @IsNotEmpty({message: '交易日期 (TU001) 不可空白'}) 
    @MaxLength(8,{message: '交易日期 (TU001) 資料太長'})
    TU001: string = '';            // 交易日期 8 struct FUTUREORDER

    @IsNotEmpty({message: '帳號 (TU002) 不可空白'}) 
    @MaxLength(20,{message: '帳號 (TU002) 資料太長'})
    TU002: string = '';            // 帳號 20 bstrFullAccount 期貨帳號，分公司代碼＋帳號7碼

    @IsNotEmpty({message: '序號 (TU003) 不可空白'}) 
    @MaxLength(4,{message: '序號 (TU003) 資料太長'})
    TU003: string = '';            // 序號 4 

    @MaxLength(10,{message: '保留 (TU004) 資料太長'})
    TU004: string = '';            // 保留 10 交易所代碼

    @MaxLength(20,{message: '商品代號 (TU005) 資料太長'})
    TU005: string = '';            // 商品代號 20 BSTR	bstrStockNo; 委託期權代號

    @IsNumber() 
    TU006: number = 0;            // 委託條件 4 [DEF:0] SHORT	sTradeType;	{{0:ROD  1:IOC  2:FOK}}

    @IsNumber() 
    TU007: number = 0;            // 買賣 4 SHORT	sBuySell;				{{0:買進 1:賣出 }}

    @IsNumber() 
    TU008: number = 0;            // 當沖 4 SHORT	sDayTrade;			//當沖 {{0:否 1:是}}

    @IsNumber() 
    TU009: number = 0;            // 倉別 4 sNewClose;			新平倉  {{0:新倉 1:平倉 2:自動}}  {新期貨、選擇權使用}

    @MaxLength(12,{message: '委託價 (TU010) 資料太長'})
    TU010: string = '';            // 委託價 12 BSTR	bstrPrice;			//委託價格(IOC and FOK，可用「M」表示市價，「P」表示範圍市價)　　　　　　　　　　　　

    @IsNumber() 
    TU011: number = 0;            // 委託口數 8 LONG	nQty;				//交易口數。

    @IsNumber() 
    TU012: number = 0;            // 盤別 4 SHORT	sReserved;		//{期貨委託SendFutureOrderCLR適用}盤別， {{0:盤中(T盤及T+1盤) 1:T盤預約}}

    @MaxLength(6,{message: '委託商品年月 (TU013) 資料太長'})
    TU013: string = '';            // 委託商品年月 6 bstrSettlementMonth;   // 委託商品年月，YYYYMM共6碼(EX: 202206) //若 bstrStockNo指定月份，需填商品契約年月

    @IsNumber() 
    TU014: number = 0;            // 委託價類別 1 nOrderPriceType; 		{{2:限價 3:範圍市價}}

    @IsNumber() 
    TU015: number = 0;            // 觸發方向 1 nTriggerDirection;  {{1:大於等於 2:小於等於}}

    @MaxLength(3,{message: '單別 (TU017) 資料太長'})
    TU017: string = '';            // 單別 3 {{0:一般 MIT:MIT單 STP:STP單 MST:MST單 OCO:OCO單 AB:AB單}}

    @MaxLength(10,{message: '登入代號 (TU018) 資料太長'})
    TU018: string = '';            // 登入代號 10 

    @MaxLength(255,{message: '備註 (TU019) 資料太長'})
    TU019: string = '';            // 備註 255 

    @MaxLength(1,{message: '暫存 (TU020) 資料太長'})
    TU020: string = 'N';            // 暫存 1 [DEF:"N"] 非同步委託 asyncOrder

    @MaxLength(255,{message: '失敗原因 (TU021) 資料太長'})
    TU021: string = '';            // 失敗原因 255 

    @MaxLength(1,{message: '價差委託 (TU022) 資料太長'})
    TU022: string = 'N';            // 價差委託 1 [DEF:"N"]

    @MaxLength(1,{message: '更新api (TU023) 資料太長'})
    TU023: string = 'N';            // 更新api 1 [DEF:"N"]

    @MaxLength(10,{message: '委託書號 (TU024) 資料太長'})
    TU024: string = '';            // 委託書號 10 BSTR	bstrBookNo;				//委託書號{改價使用}

    @MaxLength(13,{message: '委託序號 (TU025) 資料太長'})
    TU025: string = '';            // 委託序號 13 BSTR	bstrSeqNo;				//委託序號{改價使用} 13碼

    @IsNumber() 
    TU026: number = 0;            // 成交口數 8 //交易口數。

    @MaxLength(8,{message: '異動時間 (TU027) 資料太長'})
    TU027: string = '';            // 異動時間 8 hh:mm:ss

    @MaxLength(1,{message: '狀態 (TU028) 資料太長'})
    TU028: string = '1';            // 狀態 1 [DEF:"1"] {{1.已暫存 2.委託失敗 3:已刪除 5.委託成功   8:部分成交  9:全部成交}}

    @MaxLength(60,{message: '商品名稱 (TU029) 資料太長'})
    TU029: string = '';            // 商品名稱 60 

    @MaxLength(1,{message: '商品分類 (TU030) 資料太長'})
    TU030: string = '0';            // 商品分類 1 [DEF:"0"] MA019 JCKMD STKMA.MA019 {{0:上市 1:上櫃 2:期貨 3:選擇權 4:興櫃 5:盤中零股-上市 6:盤中零股-上櫃  O:海期 Z:指數}}

    @IsNumber() 
    TU031: number = 0;            // 平均成交價 11.3 


}
